import { IconType, SvgIcon } from './SvgIcon';

export const WavesIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <rect width="24" height="24" rx="12" fill="#2540F5" />
    <g clipPath="url(#clip0_8365_44980)">
      <path
        d="M6.46094 10.5186V12.7408"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 7.55566V15.7038"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2891 5.3335V18.6668"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1328 7.55469L15.0598 16.4444"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6875 10.2222V12.9108"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8365_44980">
        <rect width="14" height="16" fill="white" transform="translate(5 4)" />
      </clipPath>
    </defs>
  </SvgIcon>
);

WavesIcon.displayName = 'WavesIcon';
